import { useSettings } from "@/hooks/useSettings";

const DEFAULT_POLICY = `
<h2>Privacy Policy</h2>
<p>Your privacy is important to us. This policy explains how we collect, use, and protect your information when you use our store.</p>
<h3>Information we collect</h3>
<p>We collect information you provide when placing an order, creating an account, or contacting support.</p>
<h3>How we use it</h3>
<p>We use your information to process orders, deliver products, and improve your experience.</p>
<h3>Contact</h3>
<p>For privacy questions, please contact us through the contact page.</p>
`;

const PrivacyPolicy = () => {
  const settings = useSettings();
  const html =
    (typeof settings.privacy_policy === "string" && settings.privacy_policy) ||
    settings.privacy_policy?.html ||
    DEFAULT_POLICY;

  return (
    <section className="container py-10 max-w-3xl">
      <h1 className="font-display text-3xl md:text-4xl font-bold mb-6">
        Privacy Policy
      </h1>
      <article
        className="prose prose-sm md:prose-base max-w-none prose-headings:font-display prose-headings:font-semibold prose-a:text-primary"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </section>
  );
};

export default PrivacyPolicy;
